import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import {Fieldset, InputRow} from '../../components'
import {getUserDataFromLocalStorage, onChangeInput, validateInputs} from "../../services/utils";
import {useStyles} from "../auth/signIn/authStyles";
import {initialState, measurementUnitOption, serviceAreaOption} from "./constant";
import Alert from "../../components/alert";
import HttpService from "../../services/http.service";
import {currencyOption} from '../../environment'

export default function AddNewService(props) {
  const classes = useStyles();
  let user = getUserDataFromLocalStorage()
  const [state, setState] = useState(initialState);

  const {values, errors} = state;
  const [countries, setCountries] = useState([])
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  let nonfarming = JSON.parse(localStorage.getItem("nonfarming") || "[]")
  const arr = []
  for (let i = 0; i < nonfarming.length; i++) {
    arr.push({text: nonfarming[i].agriSectorDescription, value: nonfarming[i].agriSectorId})
  }

  useEffect(() => {
    setStateList([])
    HttpService.get('marketplace/countriesList').then(res => {
      if (res) {
        let list = res.data;
        let len = (list && list.length) || 0;
        const array = []
        for (let i = 0; i < len; i++) {
          array.push({text: list[i].countryName, value: list[i].countryID})
        }
        setCountries(array)
      }
    });
  }, []);
  useEffect(() => {
    // let country = "UAE"
    let country = values.serviceCountry
    if (country) {
      HttpService.get(`marketplace/statesByCountry/${country}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].stateName, value: list[i].stateID})
          }
          setStateList(array)
        }
      });
    }

  }, [values.serviceCountry]);
  useEffect(() => {
    // let state = "5347"
    let state = values.state
    // setCityList([])
    if (state) {
      HttpService.get(`marketplace/cityByStates/${state}`).then(res => {
        if (res) {
          let list = res.data;
          let len = (list && list.length) || 0;
          const array = []
          for (let i = 0; i < len; i++) {
            array.push({text: list[i].cityName, value: list[i].cityID})
          }
          setCityList(array)
        }
      });
    }

  }, [values.state]);

  const addService = (e) => {
    e.preventDefault();
    let {
      agriServiceId,
      agriServiceRange,
      pocName,
      agriServiceDescription,
      description,
      serviceCharges,
      serviceArea,
      currency,
      qty,
      file,
      franchise,
      certification,
      businessName,
      contactNumber,
      serviceCountry
    } = values;
    let data = {
      agriServiceId,
      agriServiceRange,
      agriServiceDescription,
      description,
      pocName,
      serviceCharges,
      serviceArea,
      currency,
      qty,
      file,
      franchise,
      certification,
      businessName,
      contactNumber,
      serviceCountry
    };

    let recordedErrors = validateInputs(data);
    if (values.serviceCharges <= 0) {
      recordedErrors.serviceCharges = "service charges should be greater then 0"
    }
    if (values.qty <= 0) {
      recordedErrors.qty = "Quantity should be greater then 0"
    }
    if (Object.keys(recordedErrors).length > 0) {
      console.log("error", recordedErrors);
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {
      let bodyFormData = new FormData();
      bodyFormData.append('file', file);
      HttpService.post(`services/addService/V2?agriServiceDescription=${agriServiceDescription}&agriServiceTypeId=${agriServiceId}&businessName=${businessName}&certification=${certification}&contactNumber=${contactNumber}&currency=${currency}&description=${description}&franchise=${franchise}&pocName=${pocName}&qty=${qty}&serviceArea=${serviceArea}&serviceCharges=${serviceCharges}&serviceCountry=${serviceCountry}&serviceRange=${agriServiceRange}&ssoId=${user.ssoId}`,
        bodyFormData).then(res => {
        if (res) {
          if (res?.data?.message == "SUCCESS")
            setSuccess(res?.data?.messageText)
          setTimeout(() => {
            props.history.push('/myservices')
          }, 3000);

          setTimeout(() => {
            setSuccess("")
          }, 8000);
        } else
          setError(res?.data?.messageText)
        setTimeout(() => {
          setError("")
        }, 8000);
      });
    }
  };

  return (
    <>
      {((error || success)) &&
      <Alert type={error ? 'error' : 'success'}
             message={error || success}/>
      }

      <Container className={`mb-20   `}>
        <div className={classes.paper} style={{marginTop: 0}}>
          <h1 className='align-self-start text-normal heading-color'>Add Service</h1>
          <form className={classes.form} noValidate>
            {/* <InputRow
              types={[
                {id: 'serviceName', value: values.serviceName, error: errors.serviceName, label: 'service Name'},

              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={3}
            /> */}
            <Fieldset
              title={'service information'}
              children={<>
                <InputRow
                  types={[
                    {
                      type: 'select',
                      value: values.agriServiceId,
                      error: errors.agriServiceId,
                      label: 'Service type',
                      id: 'agriServiceId',
                      dropdownList: arr
                    }, {
                      type: 'select',
                      value: values.serviceRange,
                      error: errors.serviceRange,
                      label: 'Range',
                      id: 'serviceRange',
                      dropdownList: serviceAreaOption
                    }, {
                      value: values.businessName,
                      error: errors.businessName,
                      label: 'business Name',
                      id: 'businessName',
                    },
                    {
                      value: values.pocName,
                      error: errors.pocName,
                      label: 'Point of Contact',
                      id: 'pocName',
                    },
                    {
                      type: 'number',
                      value: values.contactNumber,
                      error: errors.contactNumber,
                      label: 'contact number',
                      id: 'contactNumber',
                    }, {
                      value: values.serviceName,
                      error: errors.serviceName,
                      label: 'service Name',
                      id: 'serviceName',
                    },{
                      type: 'number',
                      min: 1,
                      value: values.serviceCharges,
                      error: errors.serviceCharges,
                      label: 'service Charges',
                      id: 'serviceCharges',
                    }, {
                      type: 'select',
                      value: values.currency,
                      error: errors.currency,
                      label: 'currency',
                      dropdownList: currencyOption
                    },
                    {
                      type: 'select',
                      value: values.measurementUnit,
                      error: errors.measurementUnit,
                      label: 'measurement Unit',
                      id: 'measurementUnit',
                      dropdownList: measurementUnitOption
                    }, {
                      value: values.franchise,
                      error: errors.franchise,
                      label: 'franchise',
                      // id: 'serviceCharges',
                    }, {
                      type: "file",
                      value: values.file,
                      error: errors.file,
                      label: 'Service Image',
                      id: 'file',
                      accept: 'image/*'
                    }, {
                      type: 'number',
                      value: values.qty,
                      error: errors.qty,
                      label: 'quantity',
                      id: 'qty',
                      min: 0
                    },]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={3}
                />
                <div className='mt-10'>
                  <InputRow
                    types={[
                      {
                        type: 'select',
                        value: values.serviceCountry,
                        error: errors.serviceCountry,
                        label: 'country',
                        id: "serviceCountry",
                        dropdownList: countries
                      }, {
                        type: 'select',
                        value: values.state,
                        error: errors.state,
                        label: 'state',
                        dropdownList: stateList
                      }, {
                        type: 'select',
                        value: values.serviceArea,
                        error: errors.serviceArea,
                        label: 'city',
                        id: "serviceArea",
                        dropdownList: cityList
                      },

                    ]}
                    onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                    numOfInputPerRow={3}
                  />
                </div>
                <InputRow
                  types={[
                    {
                      value: values.agriServiceDescription,
                      error: errors.agriServiceDescription,
                      label: 'Service Description',
                      id: 'agriServiceDescription',
                      maxLength: 500,
                      rows: 3
                    },
                  ]}
                  onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                  numOfInputPerRow={1}
                /></>
              }/>
            <div className='mt-30'>
              <Fieldset
                title={'certification'}
                children={<>

                  <InputRow
                    types={[
                      {
                        type: 'file',
                        value: values.certificateFile,
                        error: errors.certificateFile,
                        id: 'certificateFile',
                        label: 'certificate file',
                      },
                    ]}
                    onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                    numOfInputPerRow={3}
                  />

                  <div className='mt-10'>
                    <InputRow
                      types={[
                        {
                          value: values.certification,
                          error: errors.certification,
                          id: 'certification',
                          label: 'certificate description',
                          maxLength: 400,
                          rows: 3
                        },
                        {
                          value: values.description,
                          error: errors.description,
                          label: 'description',
                          maxLength: 400,
                          rows: 3
                        },
                      ]}
                      onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                      numOfInputPerRow={2}
                    />
                  </div>
                </>
                }/>
            </div>
            <Grid container spacing={2} className='mt-20 mb-20 pl-10  pr-10'>
              <Grid item lg={12} xs={12} className={'  display-flex justify-content-end'}>
                {/*<br></br>*/}
                <Button type="submit" variant="contained" color="primary"
                        onClick={(e) => addService(e)}>
                  Add service
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}
